import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import atavar1 from "/public/images/2@2x.png";
import atavar2 from "/public/images/t40-40.png";
import atavar3 from "/public/images/s32_32.png";
import atavar4 from "/public/images/s132_32.png";
import buriedSdk from "@/utils/zz-buried/index";
import { useWidth } from "@/utils/resize";
type Props = {};
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("home");
  const { width, display } = useWidth();
  return (
    <div className={styles["business-box"]}>
      <div className="defeaultContainer">
        <div className={styles.itemBox}>
          <div className={`${styles.item} animate-box`}>
            <div className="ant">
              <h2 className={styles.title}>{t('For Brands & Sellers')}</h2>
              <h3 className={styles.p1}>{t('businessTitle1')}</h3>
              <div
                className={styles.p}
              >{t('businessTip1')}</div>
              <h3 className={styles.p1}>
              {t('businessTitle2')}
              </h3>
              <div
                className={styles.p}
              >{t('businessTip2')}</div>
              <h3 className={styles.p1}>{t('businessTitle3')}</h3>
              <div
                className={styles.p}
              >{t('businessTip3')}</div>

              <a
                href={width> 1024?`${process.env.portalUrl}/products/sales`:`${process.env.mobileUrl}/rank?type=Goods&rankType=breakout`}
                className={styles.get}
                onClick={() => {
                  buriedSdk.buried({
                    event: `Shoplus官网_${width > 1024 ? "Web" : "H5"}`,
                    scene: `For Brands & Sellers_Get Started`,
                    URL: process.env.publicApiDomain,
                  });
                }}
              >
               {t('Get Started')}
              </a>
              <a
                href={`${width> 1024?process.env.portalUrl: process.env.mobileUrl}/checkout`}
                className={styles.plan}
                onClick={() => {
                  buriedSdk.buried({
                    event: `Shoplus官网_${width > 1024 ? "Web" : "H5"}`,
                    scene: `For Brands & Sellers_View Plans`,
                    URL: process.env.publicApiDomain,
                  });
                }}
              >
                {t('View Plans')}
              </a>
            </div>
            <div className={`${styles.itemCardWrap} ant`}>
              <div className={`${styles["i-title"]} `}>
                <div className={`${styles["i-timg"]}`}>
                  <Image src={atavar2}></Image>
                </div>
                <span className={styles.titleNum}>4,689,568</span>
              </div>
              <div className="animate-box">
                <div className={`${styles["i-t"]} ant`}>
                  <span>1</span>

                  <div className={`${styles["i-ti"]}`}>
                    <Image src={atavar4}></Image>
                  </div>
                  <span>
                    <div className={styles.sup}>{t('Sales')}</div>
                    <div className={styles.goodsNum}>120.5K</div>
                  </span>
                  <span>
                    <div className={styles.sup}>{t("Sales")}</div>
                    <div className={styles.goodsNum}>$236.3K</div>
                  </span>
                </div>
                <div className={`${styles["i-t"]} ant`}>
                  <span>2</span>

                  <div className={`${styles["i-ti"]}`}>
                    <Image src={atavar3}></Image>
                  </div>
                  <span>
                    <div className={styles.sup}>{t("Revence")}</div>
                    <div className={styles.goodsNum}>90.5K</div>
                  </span>
                  <span>
                    <div className={styles.sup}>{t("Revence")}</div>
                    <div className={styles.goodsNum}>$106.9K</div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.itemImg}`}>
        {/* <div className={`${styles.itemImgBox}`}> */}
        <Image
          src={atavar1}
          alt="best TikTok analytics tool for brands and sellers"
        ></Image>
        {/* </div> */}
      </div>
    </div>
  );
};
export default Index;
